<div class="p-4 print:hidden fade-slide-in pb-40 sm:pb-24">
  <app-compare-header></app-compare-header>

  <app-compare-items></app-compare-items>

  <app-compare-options></app-compare-options>
</div>

<app-compare-footer
  [buttonsDisabled]="!selectedItem() || loading.active() || compareStore.isCompareAddonsPending()"
  (onConfirm)="onConfirm($event)"
  (saveForLater)="saveForLater()"
></app-compare-footer>

<app-compare-print class="not-print:hidden"></app-compare-print>

@if (isFlowActive()) {
  <app-vendor-order-fields-modal
    [isOpen]="isOrderModalOpen()"
    (submitted)="onVendorFieldsSaved()"
    (cancelled)="onOrderCancelled()"
  />
}
